import { gql } from '@apollo/client';

// Query to list comments for a given videoId
export const GET_COMMENTS = gql`
  query GetComments($videoId: String!, $nextToken: String, $pageSize: Int) {
    comments(videoId: $videoId, nextToken: $nextToken, pageSize: $pageSize) {
      items {
        id
        content
        user {
          id
          name
        }
        createdAt
        isReplied
        repliedComments {
          content
          createdAt
          user {
            id
            name
          }
        }
      }
      nextToken
    }
  }
`;

// Mutation to create a new comment
export const CREATE_COMMENT = gql`
  mutation CreateComment($videoId: String!, $content: String!, $replyTo: String) {
    createComment(videoId: $videoId, content: $content, replyTo: $replyTo) {
      id
      content
      createdAt
    }
  }
`;

export const REPORT_COMMENT = gql`
  mutation ReportComment($id: String!) {
    reportComment(id: $id)
  }
`;

export const DELETE_COMMENT = gql`
  mutation DeleteComment($id: String!) {
    deleteComment(id: $id)
  }
`;

// New Workout Comments API queries
export const CREATE_WORKOUT_COMMENT = gql`
  mutation CreateWorkoutComment($workoutId: String!, $content: String!, $replyTo: String) {
    createWorkoutComment(workoutId: $workoutId, content: $content, replyTo: $replyTo) {
      id
      parentId
      content
      createdAt
      user {
        id
        name
      }
      status
    }
  }
`;


export const GET_WORKOUT_COMMENTS = gql`
  query GetWorkoutCommentList($workoutId: String!, $pageSize: Int, $nextToken: String) {
    getWorkoutCommentList(workoutId: $workoutId, pageSize: $pageSize, nextToken: $nextToken) {
      items {
        id
        parentId
        user {
          id
          name
        }
        content
        createdAt
        updatedAt
        repliedComments {
          id
          parentId
          user {
            id
            name
          }
          content
          createdAt
          updatedAt
          status
        }
        repliesCount
        status
      }
      nextToken
    }
  }
`;

export const GET_WORKOUT_COMMENT = gql`
  query GetWorkoutComment($workoutId: String!, $id: String!) {
    getWorkoutComment(workoutId: $workoutId, id: $id) {
      id
      parentId
      user {
        id
        name
      }
      content
      createdAt
      updatedAt
      repliedComments {
        id
        parentId
        user {
          id
          name
        }
        content
        createdAt
        updatedAt
        status
      }
      repliesCount
      status
    }
  }
`;

export const DELETE_WORKOUT_COMMENT = gql`
  mutation DeleteWorkoutComment($workoutId: String!, $id: String!) {
    deleteWorkoutComment(workoutId: $workoutId, id: $id) {
      id
    }
  }
`;
